import type { Mouvement } from '@mairistem/comptabilite';
import type React from 'react';
import MandatAnnulationReductionComponent from '../../../../components/Mouvement/Panel/InformationsRattachement/MandatAnnulationReductionComponent';
import type PanelComponentProps from '../../../../interfaces/pieces/mouvements/panelComponentProps';
import InformationsRattachementPanel from '../InformationsRattachementPanel';

class MandatAnnulationReductionPanel extends InformationsRattachementPanel {
	// Le bloc ne saisit que la pièce d'origine et la ligne d'origine.
	isComplete = (data: Mouvement) =>
		this.isCompleteFor(data, 'pieceOrigine', 'idLigneOriginePes');

	getComponent = function getComponent(
		data: PanelComponentProps['data'],
		onChange: PanelComponentProps['onChange'],
		handlePin: PanelComponentProps['handlePin'],
	): React.ReactElement {
		return (
			<MandatAnnulationReductionComponent
				data={data}
				handlePin={handlePin}
				onChange={onChange}
				panel={this}
			/>
		);
	};
}

export default MandatAnnulationReductionPanel;
